"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faCirclePlay = void 0;
const faCirclePlay = {
  prefix: 'fal',
  iconName: 'faCirclePlay',
  icon: [512, 512, [], '', 'M228.5 147.5C224.7 145.2 220.3 144 216 144C202.2 144 192 155.3 192 168v176c0 12.8 10.31 24 24 24c4.344 0 8.68-1.18 12.52-3.523l144-88C379.6 272.1 384 264.4 384 256c0-8.359-4.352-16.12-11.48-20.48L228.5 147.5zM224 329.7V182.3l120.7 73.73L224 329.7zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480z']
};
exports.faCirclePlay = faCirclePlay;